// extracted by css-extract-rspack-plugin
export default {"linkField":"v4U2UVXidcFB9NzZ","copyButton":"KkqUO3xUAR89tKOB"};